export default "__VITE_ASSET__DOQ7EvkB__"